module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/zh-hans_tohoku-4e87ed63da03dee4e46ffb5f8c55adb8.jpg";